export default __webpack_public_path__ + "static/Confetti-Tablet-055c4c18d2003f4a915b2ddf251c3986.svg";